<template>
	<div class="pdf-section">
		<div class="pdf-controlls flex-centerize" :class="{ 'is-loading': !isLoaded }">
			<div class="arrow" :class="{ 'is-disabled': currentPage === 1 }" @click="currentPage--"><GalleryLeftArrow /></div>
			<div class="num-pages flex-centerize">{{ currentPage }} / {{ numPages }}</div>
			<div class="arrow" :class="{ 'is-disabled': currentPage === numPages }" @click="currentPage++"><GalleryRightArrow /></div>
		</div>
		<div class="pdf-container flex-centerize">
			<div class="flex-1" v-if="!errorMessage">
				<div class="pdf-element-wrapper" v-if="isLoaded">
					<Pdf class="pdf-component" ref="myPdfComponent" :src="pdfSrc" :page="currentPage" :annotation="true"></Pdf>
				</div>
				<AppLoader v-else />
			</div>
			<div v-else>{{ errorMessage }}</div>
		</div>
	</div>
</template>

<script>
import 'pdfjs-dist/build/pdf.worker.entry';
import AppLoader from '@/components/common/AppLoader';
import GalleryLeftArrow from '@/components/BlockEditorWidget/assets/gallery-left-arrow.svg';
import GalleryRightArrow from '@/components/BlockEditorWidget/assets/gallery-right-arrow.svg';
const Pdf = () => import(/* webpackPrefetch: true */ 'pdfvuer');

export default {
	name: 'PdfViewerLegacy',
	components: {
		Pdf,
		AppLoader,
		GalleryLeftArrow,
		GalleryRightArrow,
	},
	props: {
		pdfSrc: { type: String },
	},
	watch: {
		pdfSrc: {
			handler(newV, oldV) {
				if (newV !== oldV) {
					this.isLoaded = false;
					this.retryLoading(newV);
				}
			},
			immediate: true,
		},
	},
	methods: {
		loadPdf(url) {
			Pdf().then((pdfViewer) => {
				pdfViewer
					.createLoadingTask(url)
					.then((pdf) => {
						this.numPages = pdf.numPages;
						this.isLoaded = true;
					})
					.catch((e) => {
						console.log(e);
						this.errorMessage = 'You must provide a valid PDF url';
					});
			});
		},

		retryLoading(url) {
			const retryPdfUrl = () => {
				setTimeout(() => {
					this.loadPdf(url);
					if (!this.isLoaded && this.amountRetries > 0) {
						retryPdfUrl();
						this.amountRetries--;
					}
				}, 4000);
			};
			if (this.pdfSrc) {
				retryPdfUrl();
			} else {
				console.log('No pdf for retry');
				this.errorMessage = 'You must provide a valid PDF url';
			}
		},
	},
	data() {
		return {
			currentPage: 1,
			numPages: null,
			isLoaded: false,
			amountRetries: 5,
			errorMessage: null,
			// pdfSrc: require('../../my_test_pdf.pdf'),
		};
	},
};
</script>

<style src="pdfvuer/dist/pdfvuer.css"></style>
<style scoped lang="scss">
.pdf-section {
	$max-height: 80vh;

	width: 100%;
	padding: 14px;
	background-color: #f7f7f7;

	.pdf-controlls {
		padding: 0 0 10px;

		.arrow {
			height: 28px;
			transition: 0.4s;

			&:hover {
				filter: brightness(0.9);
				cursor: pointer;
				transition: 0.4s;
			}
			&.is-disabled {
				opacity: 0.3;
				pointer-events: none;
			}
		}
		&.is-loading {
			opacity: 0.6;
			pointer-events: none;

			.arrow {
				opacity: 0.3;
				pointer-events: none;
			}
			.num-pages {
				opacity: 0;
			}
		}
	}
	.num-pages {
		min-width: 100px;
		margin: 0 10px;
		user-select: none;
	}
	.pdf-container {
		width: 100%;
		min-width: 250px;
		min-height: 250px;
		max-height: $max-height;
		overflow: hidden;
		box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
		> div,
		.pdf-element-wrapper {
			max-height: $max-height;
			overflow: hidden;
		}
	}

	.pdf-component {
		position: relative;
		display: block;
		max-height: $max-height;
		overflow-y: scroll;
	}
}
</style>
